import { render, staticRenderFns } from "./KimsaSelect.vue?vue&type=template&id=27d96f85&scoped=true&"
import script from "./KimsaSelect.vue?vue&type=script&lang=js&"
export * from "./KimsaSelect.vue?vue&type=script&lang=js&"
import style0 from "./KimsaSelect.vue?vue&type=style&index=0&id=27d96f85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d96f85",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAvatar,VDivider,VIcon,VListItem,VListItemAvatar,VListItemTitle,VSelect})
